import { Component, Input, OnInit } from '@angular/core';

export class ErrorAlertData {
    constructor(public errorTitle: string | null, public errorMessage: string | null) {}
}

@Component({
    selector: 'fb-error-alert',
    templateUrl: './error-alert.component.html',
    styleUrls: ['./error-alert.component.scss'],
})
export class ErrorAlertComponent implements OnInit {
    @Input() type: 'basic' | 'box' = 'basic';

    constructor() {}

    ngOnInit(): void {}
}
